import $ from 'jquery';
import { getState, modifyState } from '../../state';
import { getCategoryFromEvent } from './getCategoryFromEvent';
import _ from 'lodash';

export const loadSelectQuotesCategories = ({
  select,
  categories,
  eventSelected,
  projectSelected,
  allowCreateCategory = false,
  lastSelectedCategory,
}) => {
  if ($(select).length > 0) {
    $(select).empty();
  }
  for (const category of categories) {
    const newOption = new Option(
      _.capitalize(category),
      category,
      false,
      false
    );
    $(select).append(newOption).trigger('change');
  }
  if (categories.length === 0) {
    const newOption = new Option('Dedica', 'dedica', false, false);
    $(select).append(newOption).trigger('change');
  }

  const selectOptions = {
    allowClear: false,
    width: '100%',
    theme: 'bootstrap4',
    placeholder: {
      text: 'Seleziona una categoria',
    },
  };

  if (allowCreateCategory) {
    selectOptions.multiple = false;
    selectOptions.tags = true;
    selectOptions.createTag = function (tag) {
      const value = tag.term.toLowerCase().trim();
      return {
        id: value,
        text: value,
        tag: true,
      };
    };
  }

  $(select).select2(selectOptions);

  if (lastSelectedCategory) {
    $(select).val(lastSelectedCategory);
    modifyState('sidebarCurrentQuotesCategory', lastSelectedCategory);
    $(select).trigger('change');
  } else if (eventSelected) {
    const defaultCategory = getCategoryFromEvent({
      event: eventSelected,
      project: projectSelected,
      availableCategories: categories,
    });
    $(select).val(defaultCategory);
    $(select).trigger('change');
    modifyState('sidebarCurrentQuotesCategory', defaultCategory);
  } else {
    const currentCategory = getState('sidebarCurrentQuotesCategory');
    if (!currentCategory) {
      modifyState('sidebarCurrentQuotesCategory', 'dedica');
      $(select).val('dedica');
      $(select).trigger('change');
    } else {
      $(select).val(currentCategory);
      $(select).trigger('change');
    }
  }
};
